import AnalysisGateway from '../../gateways/analysis_gateway';

export default {
  name: 'analysisGateway',
  fn: AnalysisGateway
};